import { ProjectConfig } from '../types'
const projectConfig: ProjectConfig = require(`${process.env.PROJECT_NAME}/config`).default
export default projectConfig
